module.exports = __webpack_public_path__ + "img/陈志鹏.6f161c83.jpg";